/* eslint-disable */
export default {
  activeCall: 'Llamada activa',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
